import React, { FC, useEffect, useMemo, useState } from 'react';
import { Checkbox } from '../../../../components/checkbox/checkbox';
import { Divider } from '../../../../components/divider/divider';
import { pageKey } from '../../../../helpers/path';
import { useLang } from '../../../../hooks/use-lang';
import { useQueryParams } from '../../../../hooks/use-query-params';
import { IdValue, SortType } from '../../../../types/props';
import { filterByName, sortByName } from '../../helpers';
import { AlphabeticSortRadio } from '../table-alphabetic-sort/table-alphabetic-sort-radio';
import { TableFilter } from '../table-filter';
import s from './table-filter-multi-select.module.css';
import { Input } from '../../../../components/input/input';

interface Props {
  name: string;
  options?: IdValue[];
}

export const TableFilterMultiSelect: FC<Props> = (props) => {
  const { name, options = [] } = props;
  const { addQueryParams, getQueryParams } = useQueryParams();
  const ids = getQueryParams()[name];

  const [search, setSearch] = useState('');
  const [checked, setChecked] = useState<string[]>([]);

  const { t } = useLang();
  const [sortType, setSortType] = useState<SortType>('asc');

  useEffect(() => {
    setChecked(ids?.split(',') || []);
  }, [ids]);

  const handleSelect = (item: IdValue) => {
    const isChecked = checked?.some((value) => value === String(item.id));
    let result = checked;
    if (isChecked) {
      result = checked?.filter((value) => value !== String(item.id)) || [];
    } else {
      result = [...(checked || []), String(item.id)];
    }
    setChecked(result);
  };

  const onSearch = (value: React.ChangeEvent<HTMLInputElement>) =>
    setSearch(value.currentTarget.value);

  const filteredOptions = useMemo(() => {
    return options.filter((item) => filterByName(item.value, search));
  }, [options, search]);

  const sortedOptions = useMemo(() => {
    if (!sortType) {
      return filteredOptions;
    }

    return [...filteredOptions].sort((a, b) => sortByName(a.value, b.value, sortType));
  }, [filteredOptions, sortType]);

  const handleOk = () => {
    addQueryParams({ [name]: checked.join(','), [pageKey]: '1' });
  };

  const handleReset = () => {
    addQueryParams({ [name]: undefined, [pageKey]: '1' });
    setChecked([]);
  };

  return (
    <TableFilter onReset={handleReset} onSubmit={handleOk} name={name}>
      {options.length > 5 && (
        <>
          <Input value={search} onChange={onSearch} placeholder={t('Поиск')} />
          <AlphabeticSortRadio alphabetDirection={sortType} setAlphabetDirection={setSortType} />
          <Divider />
        </>
      )}
      <ul className={s.list}>
        {sortedOptions.map((item) => {
          const isChecked = checked.some((checkedItem) => String(checkedItem) === String(item.id));

          return (
            <Checkbox
              checked={isChecked}
              onClick={() => handleSelect(item)}
              label={item.value}
              key={item.id}
            />
          );
        })}
      </ul>
    </TableFilter>
  );
};
